export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10236.76de016a.jpg";